/* eslint-disable react/no-danger */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  getCancellationPolicyFormat,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';

function TermsAndConditionsForHotelRoom({ tAndC }) {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  const validTerms =
    tAndC && Array.isArray(tAndC.terms)
      ? tAndC.terms.filter((term) => {
          if (!term || typeof term !== 'string') return false;
          const content = term.includes(':')
            ? term.substring(term.indexOf(':') + 1).trim()
            : term.trim();
          return content.length > 0;
        })
      : [];

  return (
    <div style={{ border: '1px solid #374471', padding: '10px' }}>
      {tAndC &&
        tAndC.formattedpolicies &&
        getCancellationPolicyFormat(tAndC.formattedpolicies)}

      {validTerms.length > 0 && (
        <div className="mt-3 pt-2" style={{ borderTop: '1px solid #374471' }}>
          <div className="fw-600 mb-2">Terms & Conditions:</div>
          <ul
            className="ps-3 mb-0"
            style={{ fontSize: '13px', lineHeight: '1.6' }}
          >
            {validTerms.map((term, index) => (
              <li
                key={index}
                className="mb-2"
                dangerouslySetInnerHTML={{ __html: term }}
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

TermsAndConditionsForHotelRoom.propTypes = {
  tAndC: PropTypes.any.isRequired,
};

export default TermsAndConditionsForHotelRoom;
